import * as React from 'react';
import "./GroupElement.scss";
import { useMemo, useReducer, useEffect, useState } from 'react';
import { validationReducer } from '../../util/validationReducer';
import { GroupProps, GroupDefines, ChildrenValueProps } from './IGroup';
import { ElementType } from '../../common/enum/elementType';
import InputElement from '../core/InputElement';
import { Props } from '../../common/types/props';
import useActionExecutor from '../service/actionExecutor';
import { FormBuilder } from '../../common/FormBuilder';
import { ValidationErrorCode, getValidationErrorMessage, ValidationError } from '../../util/validate';
import { ColorDefines } from '../../interface/IColors';

interface GroupElementProps {
  props: GroupProps;
  defines: GroupDefines;
  colors: ColorDefines;
}

const GroupElement = ({ props, defines, colors }: GroupElementProps) => {
  const [overrideErrorMessage, setOverrideErrorMessage] = useState<ValidationError[]>([]);
  const [touched, setTouched] = useState(false);
  const [value, setValue] = useState<ChildrenValueProps>(
    props.value ? props.value :
    (defines.defaultValue ?
      defines.defaultValue.reduce((p, c) => {
        p[c.name] = {
          label: c.label,
          value: c.value,
          error: []
        }
        return p;
      }, {} as {[key: string]: any}) : []));
  const [valid, dispatchValid] = useReducer(validationReducer, {});
  const { click, change, data } = useActionExecutor(props.event, defines);
  
  useEffect(() => {
    setValue(valid);
    const keys = Object.keys(valid);
    const errorArray = Array.from(new Set(keys.reduce((p, key) => 
      p.concat(valid[key].error.map(v => v.code))
    , [] as ValidationErrorCode[])));
    setOverrideErrorMessage(errorArray.map(code => {
      const msg = getValidationErrorMessage(
        code, defines.name,
        defines.hiddenErrorPrefixLabel ? undefined : defines.label);
      return {
        code, text: msg.message
      }
    }));
  }, [valid]);

  const setTouchedWrapper = (v: boolean) => {
    setTouched(v)
    if (props.setTouched) props.setTouched(v);
  }

  const formContents = useMemo(() => {
    const contents = defines.contents.map(content => {
      return {
        props: {
          visible: props.visible,
          values: props.values,
          parentValues: (props.values as any)[defines.name],
          value: props.value ? props.value[content.name]?.value : undefined,
          dispatchValid,
          setTouched: setTouchedWrapper,
          error: valid[content.name]?.error || [],
          hideInvalidMessage: !defines.enableChildInvalid,
          getScrollTop: props.getScrollTop,
          getData: props.getData
        } as Props,
        defines: content,
        colors
      };
    });
    return FormBuilder(contents);
  }, [JSON.stringify(props.value), defines.contents]);

  return (
    <InputElement
      type={ElementType.GROUP}
      value={value}
      touched={touched}
      dispatchValid={props.dispatchValid}
      overrideErrorMessage={overrideErrorMessage}
      {...{ props, defines }}
    >
      <div className={"items" + (defines.classList ? " " + defines.classList.join(" ") : "")}>
        {formContents}
      </div>
    </InputElement>
  )
}

export default GroupElement;